import React from 'react';

export const MessageInfo = ({ text, color }) => (
  <div
    style={{
      fontSize: '25px',
      color: color || '#222',
      textAlign: 'center',
      margin: 'auto',
      marginTop: '60px',
      lineHeight: '1.8em',
      width: '80%',
    }}
  >
    {text}
  </div>
);

export default MessageInfo;
